import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from "@angular/core";
import { SvgIconComponent } from "angular-svg-icon";
import { NgClass } from "@angular/common";

export interface CardData {
  id: string;
  title: string;
  image: string;
  description: string;
  tags: Tag[];
}

export type Tag = {
  label: string;
  color: TagColor;
};

export enum TagColor {
  red = "red",
  blue = "blue",
  green = "green",
  orange = "orange",
  grey = "grey",
  purple = "purple",
  yellow = "yellow",
  teal = "teal",
  magenta = "magenta"
}

@Component({
  selector: "app-card",
  templateUrl: "./card.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./card.component.scss"],
  imports: [SvgIconComponent, NgClass]
})
export class CardComponent {
  @Input() cardData!: CardData;
  @Output() cardSelected = new EventEmitter<CardData>();

  onCardClick() {
    this.cardSelected.emit(this.cardData);
  }
}
